__turbopack_context__.v({
  "brand": "PartnershipHeader-module-scss-module__UgPx4q__brand",
  "partnership": "PartnershipHeader-module-scss-module__UgPx4q__partnership",
});
